import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB_cFg5JWhphCBrQuaTbClhSkw5SWHlBCI",
  authDomain: "my-german-flashcards-a03a8.firebaseapp.com",
  projectId: "my-german-flashcards-a03a8",
  storageBucket: "my-german-flashcards-a03a8.firebasestorage.app",
  messagingSenderId: "846463252401",
  appId: "1:846463252401:web:2c38e8eca21b5d4265af90"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
